/* eslint-disable quotes */
export default {
  init() {
    $(".tab_content").hide();
    $(".tab_content:first").show();

    /* if in tab mode */
    $("ul.tabs li").click(function () {
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).fadeIn();

      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

      $(".tab_drawer_heading").removeClass("d_active");
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
    });
    /* if in drawer mode */
    $(".tab_drawer_heading").click(function () {
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel");
      $("#" + d_activeTab).fadeIn();

      $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");

      $("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
    });

    /* Extra class "tab_last" 
	   to add border to right side
	   of last tab */
    $("ul.tabs li").last().addClass("tab_last");

    // if ($(".gallery_layout").length > 0) {
    //   $(".gallery_layout").lightGallery({
    //     // thumbnail: true,
    //     selector: ".gallery_item",
    //     exThumbImage: "data-exthumbimage",
    //     // autoplay: true,
    //     //                enableThumbSwipe: false
    //     // fullScreen: false,
    //     // download: false,
    //     captions: false,
    //     lastRow: "hide",
    //     rowHeight: 180,
    //     margins: 5,
    //   });
    // }

    $(document).ready(function () {
      var vars = [],
        hash;
      console.log(hash);
      var hashes = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
        console.log(vars[hash[0]]);
        if (vars[hash[0]] !== undefined) {
          $(".tabs-room").find("li").removeClass("active");
          $(".tabs-room")
            .find("." + vars[hash[0]])
            .addClass("active");

          $(".tab_container > .container")
            .find(".tab_drawer_heading")
            .removeClass("d_active");
          $(".tab_container > .container")
            .find("." + vars[hash[0]])
            .addClass("d_active");

          $(".tab_container  .content-tab")
            .find(".tab_content")
            .css("display", "none");
          $(".tab_container  .content-tab")
            .find("." + vars[hash[0]])
            .css("display", "block");
        }

        // if ($(".tabs-room").find("li") !== "." + vars[hash[0]]) {
        //   $(".tabs-room").find("li").removeClass("active");
        // } else {
        //   $(".tabs-room")
        //     .find("." + vars[hash[0]])
        //     .addClass("active");
        // }
      }
    });
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/templateFacilities.js